import React from 'react';
import { AlertCircle, CheckCircle, AlertTriangle } from 'lucide-react';

interface AlertProps {
  variant?: 'error' | 'success' | 'warning' | 'info';
  children: React.ReactNode;
  className?: string;
}

export function Alert({ variant = 'info', children, className = '' }: AlertProps) {
  const variantClasses = {
    error: 'alert-error',
    success: 'alert-success',
    warning: 'alert-warning',
    info: 'px-4 py-3 bg-neutral-50 border border-neutral-200 text-neutral-700 rounded-lg text-sm animate-slide-up'
  };

  const iconClasses = {
    error: 'text-error-500',
    success: 'text-success-600',
    warning: 'text-warning-600',
    info: 'text-neutral-500'
  };

  const icons = {
    error: AlertCircle,
    success: CheckCircle,
    warning: AlertTriangle,
    info: AlertTriangle
  };

  const Icon = icons[variant];
  const classes = `flex items-start gap-3 ${variantClasses[variant]} ${className}`;

  return (
    <div className={classes}>
      <Icon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${iconClasses[variant]}`} />
      <div className="flex-1">{children}</div>
    </div>
  );
}

interface AlertTitleProps {
  children: React.ReactNode;
}

export function AlertTitle({ children }: AlertTitleProps) {
  return (
    <h4 className="font-semibold mb-1">
      {children}
    </h4>
  );
}

interface AlertDescriptionProps {
  children: React.ReactNode;
}

export function AlertDescription({ children }: AlertDescriptionProps) {
  return (
    <div className="text-sm">
      {children}
    </div>
  );
}